<template>
  <div>
    <div class="icon-box">
      <v-icon x-large>mdi-horse-human</v-icon>
      <v-icon>mdi-help</v-icon>
    </div>
    <p>Page not found</p>
    <div>
      <v-btn elevation="0" color="primary">Back to home</v-btn>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
